import { EmployeeViewType } from "sh-models";
import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";

/**
 * Set the employee view type of the Schedules page.
 */
export default mutatorAction("SET_EMPLOYEE_VIEW",
    function setEmployeeView(viewState: SchedulesViewStateStore | IPreviewSchedulePageStore, employeeView: EmployeeViewType) {
        viewState.employeeViewType = employeeView;
    }
);